import { motion } from 'framer-motion';
import ReactCountryFlag from 'react-country-flag';
import { sectionAnimVariants } from '../../../constants/animationVariants';
import { useProvinceContext } from '../../../contexts/ProvinceProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import SetupCard from '../../CommonComps/Cards/SetupCard';
import SetupCardBodyInfo from '../../CommonComps/Cards/SetupCardBodyInfo';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import NoTableDataFound from '../../CommonComps/NoTableDataFound';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import AddProvinceAction from './AddProvinceAction';
import FilterProvincesDiv from './FilterProvincesDiv';

const ShowAllProvinces = () => {
  // integration of context hooks here
  const {
    provinces,
    isError,
    isLoading,
    isSuccess,
    showDeleteProvinceModalHandler,
    showEditProvinceModalHandler,
  } = useProvinceContext();

  // integration of custom hooks here
  const { featureBasedPermissions } =
    useCheckUserFeaturePermissions('province');

  // rendering show all provinces section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Provinces'
              additionalComponent={
                <AddProvinceAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
            />

            <motion.div
              variants={sectionAnimVariants}
              initial='initial'
              animate='animate'
            >
              <FilterProvincesDiv />

              {provinces.length ? (
                <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5 px-2'>
                  {provinces.map((province) => (
                    <SetupCard
                      key={province.id}
                      title={province.province_name}
                      label={province.province_name}
                      editBtnTitle='Edit Province'
                      deleteBtnTitle='Delete Province'
                      showDeleteModalHandler={
                        featureBasedPermissions.includes('DELETE')
                          ? () => showDeleteProvinceModalHandler(province)
                          : undefined
                      }
                      showEditModalHandler={
                        featureBasedPermissions.includes('UPDATE')
                          ? () => showEditProvinceModalHandler(province)
                          : undefined
                      }
                    >
                      <div className='flex items-center gap-2 text-legal-dark-blue font-semibold text-lg italic'>
                        <ReactCountryFlag
                          style={{ width: '1.2em', height: '1.2em' }}
                          countryCode={province.iso_code}
                          svg
                        />
                        <p>{province.country_name}</p>
                      </div>

                      <SetupCardBodyInfo
                        label='Legal age'
                        info={province.legal_age}
                      />
                      <SetupCardBodyInfo
                        label='Goods & Sales Tax (GST)'
                        info={province.gst}
                      />
                      <SetupCardBodyInfo
                        label='Harmonized Sales Tax (HST)'
                        info={province.hst}
                      />
                      <SetupCardBodyInfo
                        label='Provincial Sales Tax (PST)'
                        info={province.pst}
                      />
                    </SetupCard>
                  ))}
                </div>
              ) : (
                <NoTableDataFound message='No Provinces Found!!' />
              )}
            </motion.div>
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load province data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllProvinces;
